module.exports = __webpack_public_path__ + "static/img/no-results.be8162f0.png";